import React from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { useParams } from "react-router";

import { tabKeyType, columnConfigType } from "../../constants/proptypes";
import AnalysesTableHeaderCell from "./AnalysesTableHeaderCell";
import { connectToState } from "../../redux/connect-api";
import { columnConfigSelector } from "../../selectors";
import { tooltipCopy } from "../../config";

const tableHeadingStyles = (theme) => ({
  backgroundColor: `${theme.palette.common.white} !important`, // otherwise, scrolled-up rows are visible
  fontSize: "12.5px",
  lineHeight: "15px",
  fontWeight: "bold",
  padding: `${theme.spacing(0.5)} ${theme.spacing(0.5)}`, // Explicit vertical and horizontal padding
  verticalAlign: "bottom",
  "&.trade_name": {
    whiteSpace: "nowrap",
  },
  "&.icer_vbpb_price_label": {
    whiteSpace: "nowrap",
  },
  "&:first-of-type": {
    paddingLeft: theme.spacing(4),
  },
  "&:last-of-type": {
    paddingRight: theme.spacing(4),
  },
});

class AnalysesTableHeaderRow extends React.PureComponent {
  render() {
    const { columnConfig } = this.props;
    const { row1Props, row2Props } = columnConfig;
    const TOOLTIP_FIELDS = {
      date_of_review: tooltipCopy.dateOfReview,
    };
    const getTooltip = (fieldKey) => {
      const tooltipsForField = TOOLTIP_FIELDS[fieldKey];
      return tooltipsForField ? <>{tooltipsForField}</> : null;
    };
    return (
      <TableHead>
        <TableRow>
          {row1Props.map((cellProps) => (
            <AnalysesTableHeaderCell
              key={cellProps.renderKey}
              fieldKey={cellProps.fieldKey}
              colSpan={cellProps.colSpan}
              rowSpan={cellProps.rowSpan}
              className={cellProps.classes}
              align={cellProps.align}
              tooltip={getTooltip(cellProps.fieldKey)}
              sx={tableHeadingStyles}
            >
              <div>{cellProps.label}</div>
            </AnalysesTableHeaderCell>
          ))}
        </TableRow>
        <TableRow>
          {row2Props.map((cellProps) => (
            <TableCell
              key={cellProps.renderKey}
              className={cellProps.classes}
              align={cellProps.align}
              sx={tableHeadingStyles}
            >
              <div>{cellProps.label}</div>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

AnalysesTableHeaderRow.propTypes = {
  // activeTabKey from react-router
  activeTabKey: tabKeyType.isRequired,
  columnConfig: columnConfigType.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  columnConfig: columnConfigSelector(state, ownProps),
});

// Connect AnalysesTableHeaderRow (not the wrapper) so that route props are passed as ownProps
const ConnectedAnalysesTableHeaderRow = connectToState(mapStateToProps)(AnalysesTableHeaderRow);

// Export wrapper that injects router hooks and passes them as props to connected component
const AnalysesTableHeaderRowWithRouter = (props) => {
  const params = useParams();
  // Pass router props as ownProps so Redux connect sees them as changed
  // Create new object to ensure reference changes are detected
  return <ConnectedAnalysesTableHeaderRow {...props} params={{ ...params }} />;
};

export default AnalysesTableHeaderRowWithRouter;
